import { format, parseISO, isToday, getMonth, getYear } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import './BookingConfirmation.css';

const BookingConfirmationTable = ({ finalDesks, totalPrice, bookingType }) => {

    const sortedKeys = Object.keys(finalDesks).sort((a, b) => new Date(a) - new Date(b));

    const isAfter10AMUK = () => {
        if (isToday(new Date())) {
            const nowUK = formatInTimeZone(new Date(), 'Europe/London', 'HH');
            return parseInt(nowUK, 10) >= 10;
        }
        return false;
    };

    const isCurrentMonth = (dateString) => {
        const bookingDate = parseISO(dateString);
        const today = new Date();
        return getMonth(bookingDate) === getMonth(today) && getYear(bookingDate) === getYear(today);
    };

    return (
        <div className='booking-confirmation-table'>
            {bookingType === "daily" && (
                <table>
                    <tbody>
                        {sortedKeys.map((date) => {
                            const desk = finalDesks[date];
                            return (
                                <tr key={date}>
                                    <td>
                                        {format(parseISO(date), "EEE d MMM yyyy")} (7am-7pm)
                                        {isToday(parseISO(date)) && isAfter10AMUK() && (
                                            <span style={{ "fontSize": "12px", "marginLeft": "10px" }}> *50% discount after 10am</span>
                                        )}
                                    </td>
                                    <td>Desk {desk.id}</td>
                                    <td>£{desk.price}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td><strong>Total</strong></td>
                            <td><strong>£{totalPrice}</strong></td>
                        </tr>
                    </tfoot>
                </table>
            )
            }
            {
                bookingType === "monthly" && (
                    <table>
                        <tbody>
                            {sortedKeys.map((date) => {
                                const desk = finalDesks[date];
                                return (
                                    <tr key={date}>
                                        <td>
                                            {format(parseISO(date), "MMM yyyy")} (weekdays: 7am-7pm)
                                            {isCurrentMonth(date) && (
                                                <span style={{ "fontSize": "12px", "marginLeft": "10px" }}> *pro-rated from 1st</span>
                                            )}
                                        </td>
                                        <td>Desk {desk.id}</td>
                                        <td>£{desk.price}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td><strong>Total</strong></td>
                                <td><strong>£{totalPrice}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                )
            }
        </div >
    );
}

export default BookingConfirmationTable;